import { Box, Tooltip, Typography, withStyles } from "@material-ui/core"
import { COLOR_BLACK, COLOR_WHITE } from "../../../constants"
import LegendItem from "./LegendItem"
import { useIsSmallScreen } from "../../../hooks/use-is-small-screen"

const HorizontalBarChart = ({ labels, data }: HorizontalBarChartProps) => {
  const isSmallScreen = useIsSmallScreen()

  return (
    <Box>
      <Box display="flex" flexDirection="row" flexWrap="wrap" mb={2} mt={2}>
        {labels.map((item, index) => (
          <LegendItem
            key={index}
            label={item.label}
            color={item.boxColor}
            percentage={data[index]?.percentage}
            count={data[index]?.value}
          />
        ))}
      </Box>
      <Box display="flex" width="100%" height="72px" borderRadius="4px" overflow="hidden">
        {data.map((item, index) => (
          <WhiteTooltip
            key={index}
            title={
              <Box>
                <Typography variant="body1" style={{ fontWeight: "bold", marginBottom: "4px" }}>
                  {labels[index].label}:
                  <span style={{ marginLeft: "4px" }}>
                    {data[index]?.percentage}% ({data[index]?.value})
                  </span>
                </Typography>
                {item.tooltipContent.map((item, index) => (
                  <Typography key={index} variant="body1" style={{ display: "block" }}>
                    {`• ${item}`}
                  </Typography>
                ))}
              </Box>
            }
            interactive
          >
            <Box
              width={`${item.percentage}%`}
              bgcolor={item.backgroundColor}
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              {Number.parseFloat(item.percentage) > 5 && (
                <Box display="flex" flexDirection="column" alignItems="center">
                  <Typography
                    variant="body2"
                    style={{ color: COLOR_WHITE, fontWeight: "bold", fontSize: isSmallScreen ? "12px" : "16px" }}
                  >
                    {item.percentage}%
                  </Typography>
                  <Typography
                    variant="body2"
                    style={{ color: COLOR_WHITE, fontWeight: "bold", fontSize: isSmallScreen ? "12px" : "16px" }}
                  >
                    {item.value}
                  </Typography>
                </Box>
              )}
            </Box>
          </WhiteTooltip>
        ))}
      </Box>
    </Box>
  )
}

export default HorizontalBarChart
type HorizontalBarChartProps = {
  labels: { label: string; boxColor: string }[]
  data: { value: number; percentage: string; tooltipContent: string[]; backgroundColor: string }[]
}

const WhiteTooltip = withStyles({
  tooltip: {
    backgroundColor: COLOR_WHITE,
    color: COLOR_BLACK,
    boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)",
    fontSize: "0.875rem",
    maxHeight: "400px",
    overflowY: "scroll",
  },
})(Tooltip)
